export interface DocumentDto {
    date: string;
    id: number;
    name: string;
    fileExtension: string;
    changeTime: Date;
    mimeType: string;
    type: DocumentationType;
    status: DocumentStatus;
    downloadRequest: DocumentDonwloadRequest;
}

export enum DocumentStatus {
    Available,
    MissingSignature,
}

export enum DocumentationType {
    SavingsAccountStatements,
    SavingsAccountContracts,
    MortgageContracts,
    GeneralTerms,
}

export interface DocumentDonwloadRequest {
    type: string;
    objectId: number;
    version: number;
    file: string;
}



// WEBPACK FOOTER //
// ./src/util/DTOs/DocumentationsDtos.ts